

document.addEventListener('click', function(e){
  if ( typeof e.target.id !== undefined && (e.target.id == 'pn-modal-close-btn' || e.target.id == 'pn-mixed-cart-warning')) {
    document.getElementById('pn-mixed-cart-warning').classList.remove('pn-manual-modal-container');
    if (!document.body.classList.contains('template--cart')) {
      document.querySelector('.off-canvas--right-sidebar .cart--checkout-button button[name="checkout"]').click();
    }
  }
}); 

//window.addEventListener('theme:cart:updated', function(){
document.addEventListener('click', function(e) {
  if (e.target == document.querySelector('.off-canvas--right-sidebar .cart--checkout-button')) {
    let cartItems = document.querySelectorAll('.off-canvas--right-sidebar .cart--body .cart--item');
    let hasRegularItem = false;
    let hasPreOrderItem = false;
    cartItems.forEach(element => {
      if (element.innerHTML.includes('Pre-order')) {
        hasPreOrderItem = true;
      }
      if (!element.innerHTML.includes('Pre-order')) {
        hasRegularItem = true;
      }
    });
    if (hasPreOrderItem && hasRegularItem) {
      if (document.getElementById('pn-mixed-cart-warning')) {
        document.getElementById('pn-mixed-cart-warning').innerHTML = `<div id="pn-mixed-cart-warning-content" class="pn-manual-modal-content">
          <span id="pn-modal-close-btn">x</span>
          <h2 id="pn-mixed-cart-warning-title">Heads up: you have pre-order and in-stock items in the same cart!</h2>
          <div id="pn-mixed-cart-warning-text">You have a pre-order item in your cart. Your in-stock items will ship within 1-4 business days, but your pre-order item will be shipped at a later date. Please review the product's description for shipment date. Discounts cannot be applied to pre-order items as sales are hosted by Destira on behalf of the gym. If you have other questions or need immediate assistance please contact us at support@destira.com. </div>
        </div>`;
      } else {
        document.body.insertAdjacentHTML('beforeend', `<div id="pn-mixed-cart-warning" class="pn-modal pn-manual-modal-container" style="display: none;">
          <div id="pn-mixed-cart-warning-content" class="pn-manual-modal-content">
            <span id="pn-modal-close-btn">x</span>
            <h2 id="pn-mixed-cart-warning-title">Heads up: you have pre-order and in-stock items in the same cart!</h2>
            <div id="pn-mixed-cart-warning-text">You have a pre-order item in your cart. Your in-stock items will ship within 1-4 business days, but your pre-order item will be shipped at a later date. Please review the product's description for shipment date. Discounts cannot be applied to pre-order items as sales are hosted by Destira on behalf of the gym. If you have other questions or need immediate assistance please contact us at support@destira.com. </div>
          </div>
        </div>`);
      }
      document.getElementById('pn-mixed-cart-warning').classList.add('pn-manual-modal-container');
    } else {
      document.querySelector('.off-canvas--right-sidebar .cart--checkout-button button[name="checkout"]').click();
    }
  }
});

let relatedProductsInterval;

window.addEventListener('theme:cart:updated', function (e) {
  if (relatedProductsInterval) clearInterval(relatedProductsInterval); // clear any existing interval

  let attempts = 0;
  const maxAttempts = 5;

  relatedProductsInterval = setInterval(async function () {
    attempts++;
    const cart_item = document.querySelector('.drawer--root .cart--body .cart--item');

    if (cart_item) {
      const product_id = cart_item.getAttribute('data-product-id');
      const block = document.querySelector('.drawer--root .related-products--root');
      const container = document.querySelector('.drawer--root .related-products--root .related-products--grid');


      try {
        const res = await fetch(`${theme.urls.product_recommendations}?section_id=related-products&limit=4&product_id=${product_id}&intent=related`);
        if (!res.ok) throw new Error(res.statusText);

        const html = await res.text();
        const items = theme.utils.parseHtml(html).querySelectorAll("[data-product-item]");


        if (items.length) {
          const fragment = new DocumentFragment();
          items.forEach(item => fragment.append(item));

          container.innerHTML = "";
          container.appendChild(fragment);
          
          block.style.display = "block";
          if (container) container.style.display = "block";

          clearInterval(relatedProductsInterval); 
        } else {
          if (block) block.style.display = "none";
        }
      } catch (err) {
        console.error("Error fetching related products:", err);
      }
    }

    if (attempts >= maxAttempts) {
      clearInterval(relatedProductsInterval); 
    }
  }, 1000); 
});


// window.addEventListener('theme:cart:updated', async function(e) {
//   var cart_item = document.querySelector('.drawer--root .cart--body .cart--item');

//   if (typeof cart_item !== 'undefined') {
//     var product_id = cart_item.getAttribute('data-product-id');
//     var block = document.querySelector('.drawer--root .related-products--root');
//     var container = document.querySelector('.drawer--root .related-products--root .related-products--grid');
//     var t = await fetch(`${theme.urls.product_recommendations}?section_id=complementary-products&limit=2&product_id=${product_id}&intent=complementary`);
//     if (!t.ok) throw new Error(t.statusText);
//     var e = await t.text(),
//       o = theme.utils.parseHtml(e).querySelectorAll("[data-product-item]");
//     if (o.length) {
//       const s = new DocumentFragment;
//       o.forEach(t => s.append(t)), container.innerHTML = "", container.appendChild(s), block.style.display = "block"
//     } else block && (block.style.display = "none")
//   }
// });


var isInViewport = function (elem) {
  var bounding = elem.getBoundingClientRect();
  return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

document.addEventListener("scroll", async (event) => {
  const nextButton = document.querySelector('.collection--body--pagination .view-more');
  if (typeof nextButton === "undefined" || nextButton == null) {
    return false;
  }

  var nextPage = nextButton.getAttribute('data-next');
  var isLoading = nextButton.getAttribute('is-loading');
  if (isLoading == "false" && isInViewport(nextButton)) {
    nextButton.setAttribute('is-loading', 'true');
    
    if (nextPage == null) {
      nextPage = 2;
    } else if (nextPage == 'none') {
      return false;
    }

    var url = location.href;
    if (url.includes('?')) {
      url = location.href + `&page=${nextPage}`;
    } else {
      url = location.href + `?page=${nextPage}`;
    }
    
    const response = await fetch(url);
    const htmlString = await response.text();
    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');

    if ( typeof html.body !== "undefined" && html.body.querySelectorAll('.collection--body--grid .product--root').length > 0) {
      document.querySelector('.collection--body--grid').insertAdjacentHTML('beforeend', html.body.querySelector('.collection--body--grid').innerHTML);
      nextButton.setAttribute('data-next', parseInt(nextPage)+1);
      nextButton.setAttribute('is-loading', 'false');
    } else {
      nextButton.setAttribute('data-next', 'none');
      //nextButton.style.display = 'none';
    }
  }
  return false;
});

var shipping_collapsible_block = document.querySelector('body.wholesale .product-page--info [data-block-type="collapsible-row"]:last-child');
if (typeof shipping_collapsible_block !== 'undefined' && shipping_collapsible_block != null) {
  shipping_collapsible_block.querySelector('.collapsible-row--content').innerHTML = `<p><strong>SHIPPING:</strong></p><p>Rates and delivery time will vary depending on delivery location, chosen shipment method, carrier capacity and possible other factors.</p><p>Free standard shipping over $99 for contiguous continental US!</p><p>International shipping to Canada, Mexico, Australia and New Zealand. Both pre-paid and post-paid taxes and duties options available at checkout.</p><p><em>*Destira is not responsible for lost or stolen packages, or courier delays due to natural disasters or current events once the package leaves the Destira distribution center.</em></p><p><strong>RETURNS:</strong></p><p>Wholesale orders are not eligible for return. For assistance, please contact <a href="mailto:proshop@destira.com">proshop@destira.com</a></p>`
}

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
}
window.addEventListener('resize', appHeight);
appHeight();
document.addEventListener("click", async (event) => {
  if (event.target == document.querySelector('.product-buy-buttons--smart--overlay')) {
    document.querySelector('.alert-message').classList.add("open");
  }
});

jQuery(document).ready(function(){
  checkIwishCount(2000);     
  jQuery("body").on("click",".iWishAdd, .iWishAddColl, .iwish-backdrop,.iwish_drawer_close",function(){
       checkIwishCount(500);
  });      
  function checkIwishCount(timer){          
      setTimeout(function(){
        var iwC1 = Number($('.iwish-counter').text());
        //console.log("iwC1: ",iwC1);            
        if(iwC1 > 0) {              
           $('.iwCountShow').show();
        }                                                         
        else {              
           $('.iwCountShow').hide();
        }                                   
      },timer);                                   
  }             
});

/* Quick Cart JS START ================================================ */
document.addEventListener("DOMContentLoaded", function () {
  const screenWidth = window.innerWidth;
  if (screenWidth >= 576) {
  const layoutViewport = document.querySelector(".layout--viewport");
  const targetContainer = document.querySelector(".ymlk-get");

  if (!layoutViewport || !targetContainer) {
    return;
  }

  const moveRelatedProducts = () => {
    const relatedProducts = document.querySelector(".cstm-cart-drawer .related-products--root");
    const isDrawerOpen = layoutViewport.getAttribute("data-drawer-status") === "opened";

    if (isDrawerOpen) {
      if (relatedProducts && !targetContainer.contains(relatedProducts)) {
        targetContainer.appendChild(relatedProducts);
      }
      targetContainer.classList.add("active-related-products");
    } else {
      targetContainer.classList.remove("active-related-products");
    }
  };

  // Watch for attribute changes on layout--viewport
  const drawerStatusObserver = new MutationObserver(() => {
    moveRelatedProducts();
  });

  drawerStatusObserver.observe(layoutViewport, {
    attributes: true,
    attributeFilter: ["data-drawer-status"],
  });

  // Watch DOM for related-products--root being added dynamically
  const contentObserver = new MutationObserver(() => {
    moveRelatedProducts();
  });

  contentObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  moveRelatedProducts();
}
});

// ************* BACK BUTTON TO DISPLAY AND SHOW PRODUCT AND CART  *************
document.addEventListener("DOMContentLoaded", function () {

  const layoutViewport = document.querySelector('.layout--viewport');
  const drawer = document.querySelector('.drawer--instance[data-side="right"]');
  const clickableSelectors = ['.cstm-card-click', '.collection--body--grid'];

  if (!drawer || !layoutViewport) return;

  let drawerContentObserver = null;
  let productFormObserver = null;
  let viewportObserver = null;
  let attrObserver = null;
  let closedStateProductFormObserver = null;
  let isInitialized = false;

  // NEW: Use event delegation for persistent click handling
  function setupEventDelegation() {
    // Remove any existing delegated listeners to prevent duplicates
    document.removeEventListener('click', handleDelegatedClick);
    
    // Add delegated click listener to document
    document.addEventListener('click', handleDelegatedClick);
  }
 
  // NEW: Delegated click handler
  function handleDelegatedClick(event) {
    // Check if clicked element matches our selectors
    const clickedElement = event.target.closest('.cstm-card-click, .collection--body--grid');
    
    if (clickedElement) {
      //console.log('Card clicked - triggering product form'); // Debug log
      
      const checkDrawerStatusInterval = setInterval(() => {
        const drawerStatus = layoutViewport.getAttribute('data-drawer-status');
        const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
        
        if (drawerStatus === 'opened' && productForm) {
          productForm.style.display = 'block';
          //console.log('Product form displayed'); // Debug log
          clearInterval(checkDrawerStatusInterval);
        }
      }, 100);
      
      setTimeout(() => clearInterval(checkDrawerStatusInterval), 3000);
    }
  }

  // UPDATED: Re-attach event listeners when content changes
  function reattachClickListeners() {
    clickableSelectors.forEach(selector => {
      const clickables = document.querySelectorAll(selector);
      clickables.forEach(clickable => {
        // Remove existing listener to prevent duplicates
        clickable.removeEventListener('click', handleDirectClick);
        // Add fresh listener
        clickable.addEventListener('click', handleDirectClick);
      });
    });
  }

  // NEW: Direct click handler (backup method)
  function handleDirectClick(event) {
    console.log('Direct click handler triggered'); // Debug log
    
    const checkDrawerStatusInterval = setInterval(() => {
      const drawerStatus = layoutViewport.getAttribute('data-drawer-status');
      const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
      
      if (drawerStatus === 'opened' && productForm) {
        productForm.style.display = 'block';
        //console.log('Product form displayed via direct click'); // Debug log
        clearInterval(checkDrawerStatusInterval);
      }
    }, 100);
    
    setTimeout(() => clearInterval(checkDrawerStatusInterval), 3000);
  }

  // ORIGINAL: Keep original method as fallback
  function setupOriginalClickListeners() {
    clickableSelectors.forEach(selector => {
      const clickable = document.querySelector(selector);
      if (clickable) {
        clickable.addEventListener('click', () => {
          const checkDrawerStatusInterval = setInterval(() => {
            const drawerStatus = layoutViewport.getAttribute('data-drawer-status');
            const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
            if (drawerStatus === 'opened' && productForm) {
              productForm.style.display = 'block';
              clearInterval(checkDrawerStatusInterval);
            }
          }, 100);
          setTimeout(() => clearInterval(checkDrawerStatusInterval), 3000);
        });
      }
    });
  }

  function observeDrawerContent() {
    if (drawerContentObserver) drawerContentObserver.disconnect();

    drawerContentObserver = new MutationObserver(() => {
      const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
      const cartDrawer = document.querySelector('.cstm-cart-drawer');

      if (productForm && cartDrawer) {
        checkAndApplyBackButtonToVisibleForms();
        if (!productFormObserver) {
          watchProductFormChanges(productForm);
        }
        watchCartItemChanges();
        
        // NEW: Re-attach click listeners when content changes
        reattachClickListeners();
      }
    });

    drawerContentObserver.observe(drawer, { childList: true, subtree: true });

    const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
    if (productForm && !productFormObserver) {
      watchProductFormChanges(productForm);
    }
    checkAndApplyBackButtonToVisibleForms();
    watchCartItemChanges();
    watchCartDrawerChangesForYmlkGet();
    
    // NEW: Ensure click listeners are attached
    reattachClickListeners();
  }

  function watchProductFormWhenClosed() {
    if (closedStateProductFormObserver) closedStateProductFormObserver.disconnect();

    const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
    if (!productForm) return;

    closedStateProductFormObserver = new MutationObserver(() => {
      const drawerStatus = layoutViewport.getAttribute('data-drawer-status');

      if (drawerStatus === 'closed') {
        const cartDrawer = document.querySelector('.cstm-cart-drawer');
        productForm.style.display = 'block';
        if (cartDrawer) cartDrawer.style.display = 'none';
        checkAndApplyBackButtonToVisibleForms();
        
        // NEW: Re-attach click listeners when drawer closes
        reattachClickListeners();
      }
    });
 
    closedStateProductFormObserver.observe(productForm, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  function checkAndApplyBackButtonToVisibleForms() {
    const productFormContainer = document.querySelector('.drawer--container[data-view="product-form"]');
    if (!productFormContainer) return;

    const quickAddForms = productFormContainer.querySelectorAll('.product--quick-add--form');
    quickAddForms.forEach((form) => {
      const currentStyle = form.getAttribute('style') || '';
      const computedStyle = window.getComputedStyle(form);
      const isHiddenByStyle = currentStyle.includes('display: none') || currentStyle.includes('display:none');
      const isHiddenByComputed = computedStyle.display === 'none';

      if (!isHiddenByStyle && !isHiddenByComputed) {
        const backButton = form.querySelector('.back-to-cart');
        if (backButton) {
          backButton.removeEventListener('click', handleBackClick);
          backButton.addEventListener('click', handleBackClick);
        }
      }
    });
  }

  function removeDisplayNoneFromQuickAddForms() {
    const productFormContainer = document.querySelector('.drawer--container[data-view="product-form"]');
    if (!productFormContainer) return;

    const quickAddForms = productFormContainer.querySelectorAll('.product--quick-add--form');
    quickAddForms.forEach((form) => {
      const currentStyle = form.getAttribute('style') || '';
      if (currentStyle.includes('display: none') || currentStyle.includes('display:none')) {
        let newStyle = currentStyle
          .replace(/display\s*:\s*none\s*;?/gi, '')
          .replace(/;\s*;/g, ';')
          .replace(/^;\s*|;\s*$/g, '')
          .trim();

        if (newStyle === '') {
          form.removeAttribute('style');
        } else {
          form.remove('style', newStyle);
        }
      }
    });
  }
  

  function cleanupProductFormStyles() {
    const productFormContainer = document.querySelector('.drawer--container[data-view="product-form"]');
    if (!productFormContainer) return;

    const containerDisplayStyle = productFormContainer.style.display;
    const elementsWithStyle = productFormContainer.querySelectorAll('[style]');

    elementsWithStyle.forEach((element) => {
      if (element === productFormContainer) return;

      const currentStyle = element.getAttribute('style') || '';
      let cleanedStyle = currentStyle
        .replace(/display\s*:\s*none\s*;?/gi, '')
        .replace(/visibility\s*:\s*hidden\s*;?/gi, '')
        .replace(/opacity\s*:\s*0\s*;?/gi, '')
        .replace(/;\s*;/g, ';')
        .replace(/^;\s*|;\s*$/g, '')
        .trim();

      if (cleanedStyle === '') {
        element.removeAttribute('style');
      } else if (cleanedStyle !== currentStyle) {
        element.setAttribute('style', cleanedStyle);
      }
    });

    if (containerDisplayStyle === 'none' || !containerDisplayStyle) {
      productFormContainer.style.display = 'none';
    }
  }

  function handleBackClick() {
    const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
    const cartDrawer = document.querySelector('.cstm-cart-drawer');

    if (productForm) {
      productForm.style.display = 'none';
      removeDisplayNoneFromQuickAddForms();
      watchProductFormChanges(productForm);
    }

    if (cartDrawer) {
      cartDrawer.style.display = 'block';
    }
  }

  function watchProductFormChanges(productForm) {
    if (productFormObserver) productFormObserver.disconnect();

    const cartDrawer = document.querySelector('.cstm-cart-drawer');
    productFormObserver = new MutationObserver(() => {
      const drawerStatus = layoutViewport.getAttribute('data-drawer-status');
      const isDrawerExpanded = drawer.getAttribute('aria-expanded') === 'true';

      if (drawerStatus === 'opened' && isDrawerExpanded) {
        if (window.forceCartDrawerView) {
          return;
        }
        productForm.style.display = 'block';
        if (cartDrawer) cartDrawer.style.display = 'none';
        checkAndApplyBackButtonToVisibleForms();
      }
    });

    productFormObserver.observe(productForm, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  function watchCartItemChanges() {
    const cartDrawer = document.querySelector(".cstm-cart-drawer[data-view='cart-drawer']");
    const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
    if (!cartDrawer || !productForm) return;

    let lastItemCount = cartDrawer.querySelectorAll(".cart--item").length;
    const cartObserver = new MutationObserver(() => {
      const currentItemCount = cartDrawer.querySelectorAll(".cart--item").length;
      if (currentItemCount > lastItemCount) {
        if (productFormObserver) productFormObserver.disconnect();
        productForm.style.display = "none";
        cartDrawer.style.display = "block";
        lastItemCount = currentItemCount;
        watchProductFormChanges(productForm);
      }
    });
    cartObserver.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Programmatic switch to cart drawer view, used by quick view add-to-cart flows
  window.showCartDrawerView = function() {
    const cartDrawer = document.querySelector('.cstm-cart-drawer');
    const productForm = document.querySelector('.drawer--container[data-view="product-form"]');

    if (productFormObserver) productFormObserver.disconnect();
    if (productForm) productForm.style.display = 'none';
    if (cartDrawer) cartDrawer.style.display = 'block';

    // Temporarily prevent productForm observer from flipping views back
    window.forceCartDrawerView = true;
    setTimeout(() => {
      window.forceCartDrawerView = false;
      if (productForm) watchProductFormChanges(productForm);
    }, 1500);
  }

  function watchCartDrawerChangesForYmlkGet() {
    const cartDrawer = document.querySelector('.cstm-cart-drawer');
    const ymlkGet = document.querySelector('.ymlk-get');

    if (!cartDrawer || !ymlkGet) return;

    const updateYmlkVisibility = () => {
      const cartBody = cartDrawer.querySelector('.cart--body');
      const hasItems = cartBody && cartBody.children.length > 0;

      if (hasItems) {
        ymlkGet.style.display = 'block';
      } else {
        ymlkGet.style.display = 'none';
      }
    };

    const observer = new MutationObserver(() => {
      updateYmlkVisibility();
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });

    updateYmlkVisibility();
  }

  function resetView() {
    const productForm = document.querySelector('.drawer--container[data-view="product-form"]');
    const cartDrawer = document.querySelector('.cstm-cart-drawer');

    if (productForm) {
      productForm.style.display = 'none';
      removeDisplayNoneFromQuickAddForms();
      if (!productFormObserver) watchProductFormChanges(productForm);
    }

    if (cartDrawer) {
      cartDrawer.style.display = 'block';
    }
    
    // NEW: Re-attach click listeners when resetting view
    reattachClickListeners();
  }

  function resetAllJS() {
    cleanupProductFormStyles();
    resetView();

    if (drawerContentObserver) drawerContentObserver.disconnect();
    if (closedStateProductFormObserver) closedStateProductFormObserver.disconnect();

    const allBackButtons = document.querySelectorAll('.back-to-cart');
    allBackButtons.forEach((button) => {
      button.removeEventListener('click', handleBackClick);
    });

    watchProductFormWhenClosed();
    
    // NEW: Re-attach click listeners after reset
    reattachClickListeners();
  }

  function initializeMainObservers() {
    if (isInitialized) return;

    viewportObserver = new MutationObserver(() => {
      const drawerStatus = layoutViewport.getAttribute('data-drawer-status');

      if (drawerStatus === 'closed') {
        resetAllJS();
      } else if (drawerStatus === 'opened') {
        if (closedStateProductFormObserver) {
          closedStateProductFormObserver.disconnect();
          closedStateProductFormObserver = null;
        }
        observeDrawerContent();
        checkAndApplyBackButtonToVisibleForms();
        
        // NEW: Re-attach click listeners when drawer opens
        reattachClickListeners();
      }
    });

    viewportObserver.observe(layoutViewport, {
      attributes: true,
      attributeFilter: ['data-drawer-status']
    });

    attrObserver = new MutationObserver(() => {
      const isExpanded = drawer.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        if (!drawerContentObserver) observeDrawerContent();
        checkAndApplyBackButtonToVisibleForms();
        
        // NEW: Re-attach click listeners when drawer expands
        reattachClickListeners();
      } else {
        resetView();
      }
    });

    attrObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-expanded']
    });

    isInitialized = true;

    const initialDrawerStatus = layoutViewport.getAttribute('data-drawer-status');
    if (initialDrawerStatus === 'closed') {
      watchProductFormWhenClosed();
    }
    
    // NEW: Initial setup of click listeners
    setupEventDelegation();
    reattachClickListeners();
  }

  function cleanup() {
    if (drawerContentObserver) drawerContentObserver.disconnect();
    if (productFormObserver) productFormObserver.disconnect();
    if (viewportObserver) viewportObserver.disconnect();
    if (attrObserver) attrObserver.disconnect();
    if (closedStateProductFormObserver) closedStateProductFormObserver.disconnect();
    
    // NEW: Clean up delegated event listener
    document.removeEventListener('click', handleDelegatedClick);
  }

  window.addEventListener('beforeunload', cleanup);
  initializeMainObservers();

});
/* Quick Cart JS END ================================================ */

// Function to remove "review" or "reviews" from the text
function cleanReviewText(el) {
  if (el && el.textContent) {
    const newText = el.textContent.replace(/\s*reviews?\b/i, '').trim();
    if (el.textContent !== newText) {
      el.textContent = newText;
    }
  }
}

// Observe text content changes on the rating element
function observeTextContent(el) {
  if (!el) return;

  // Skip if already observed
  if (el.dataset.observed === 'true') return;
  el.dataset.observed = 'true';

  const observer = new MutationObserver(() => cleanReviewText(el));
  observer.observe(el, {
    characterData: true,
    childList: true,
    subtree: true,
  });

  // Initial clean
  cleanReviewText(el);
}

// Main MutationObserver for DOM additions
const domObserver = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const ratingEls = node.matches('.ymlk-get .stjr-product-rating-widget__avg-rating')
            ? [node]
            : node.querySelectorAll('.ymlk-get .stjr-product-rating-widget__avg-rating');
          ratingEls.forEach(observeTextContent);
        }
      });
    }
  }
});

// Start observing the full document
domObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// Initial pass for any pre-existing elements
document.querySelectorAll('.ymlk-get .stjr-product-rating-widget__avg-rating').forEach(observeTextContent);

// Fallback: Use setInterval, then auto-clear it when all text is cleaned
const intervalId = setInterval(() => {
  let allCleaned = true;

  document.querySelectorAll('.ymlk-get .stjr-product-rating-widget__avg-rating').forEach((el) => {
    const original = el.textContent;
    const cleaned = original.replace(/\s*reviews?\b/i, '').trim();

    if (original !== cleaned) {
      el.textContent = cleaned;
      allCleaned = false; // Still had "review"/"reviews", so keep interval running
    }
  });

  // If nothing left to clean, clear interval
  if (allCleaned) {
    clearInterval(intervalId);
  }
}, 500); // Faster interval for quick removal

// Radio Input Update on the after the Product title
 document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
    // Match any element with class 'radios--value-button'
    const button = event.target.closest('.radios--value-button');
    if (!button) return;

    // Find the nearest parent container (drawer or quick add)
    const container = button.closest('.drawer--container, .product--quick-add--form');
    if (!container) return;

    const value = button.getAttribute('data-value');

    // Update the variant display inside the same container
    const variantDisplay = container.querySelector('.pr_variant');
    if (variantDisplay) {
      variantDisplay.textContent = value;
    }
  });
});

  //WIshlist 
function checkWishlistStatus() {
  const localData = localStorage.getItem('iWishlistmain');
  if (!localData) return;

  let parsedData;
  try {
    parsedData = JSON.parse(localData);
  } catch (e) {
    console.error('Failed to parse iWishlistmain:', e);
    return;
  }

  document.querySelectorAll('.ymlk-get .product--root').forEach(productRoot => {
    const wishlistBtn = productRoot.querySelector('.iWishAddColl');
    if (!wishlistBtn) return;

    const productId = wishlistBtn.getAttribute('data-product');
    const variantId = wishlistBtn.getAttribute('data-variant');

    if (parsedData[productId] && parsedData[productId].includes(variantId)) {
      wishlistBtn.classList.add('iwishAdded');
    }
  });
}

function observeWishlistStructure() {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      mutation.addedNodes.forEach(node => {
        if (
          node.nodeType === 1 &&
          node.matches('.ymlk-get .product--root, .ymlk-get .product--root *')
        ) {
          checkWishlistStatus();
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Run initially on page load
  checkWishlistStatus();
}

document.addEventListener('DOMContentLoaded', observeWishlistStructure);

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
    const ctaButton = event.target.closest('.product-buy-buttons--cta');
    if (!ctaButton) return;

    const drawerContainer = ctaButton.closest('.drawer--container[data-view="product-form"]');
    if (!drawerContainer) return;

    // Loop through all product quick add forms
    const quickAddForms = drawerContainer.querySelectorAll('.product--quick-add--form');
    quickAddForms.forEach(function (form) {
      const radioInputs = form.querySelectorAll('.radios--input');
      const alertMessage = form.querySelector('.alert-message');
      
      // Only proceed if there are radio inputs AND an alert message exists
      if (radioInputs.length > 0 && alertMessage) {
        const isAnyChecked = Array.from(radioInputs).some(input => input.checked);
        
        if (!isAnyChecked) {
          alertMessage.classList.add('open');
        } else {
          alertMessage.classList.remove('open');
        }
      }
      // If there are no radio inputs, we do nothing (don't show alert)
    });
  });
});



// Minus button
document.addEventListener("click", function (e) {
  if (e.target.matches(".variant-quantity .quantity-selector--minus")) {
    e.preventDefault();

    const input = e.target.parentElement.querySelector('input[type="text"]');
    let current = parseInt(input.value) || 0;

    if (current > 0) {
      input.value = current - 1;
      input.setAttribute("value", current - 1);

      // Trigger "change" event manually
      input.dispatchEvent(new Event("change", { bubbles: true }));
      // quantityChange(); // Uncomment if needed
    }

    // Trigger recalculation on the nearest bulk-buy component
    const host = e.target.closest("product-bulk-buy-buttons-root");
    if (host && typeof host.recalculateTotals === "function") {
      host.recalculateTotals();
    }
  }
});

// Plus button
document.addEventListener("click", function (e) {
  if (e.target.matches(".variant-quantity .quantity-selector--plus")) {
    e.preventDefault();
    const input = e.target.parentElement.querySelector('input[type="text"]');
    let current = parseInt(input.value) || 0;

    if (current >= 0) {
      input.value = current + 1;
      input.setAttribute("value", current + 1);

      // Trigger "change" event manually
      input.dispatchEvent(new Event("change", { bubbles: true }));
      // quantityChange(); // Uncomment if needed
    }

    // Trigger recalculation on the nearest bulk-buy component
    const host = e.target.closest("product-bulk-buy-buttons-root");
    if (host && typeof host.recalculateTotals === "function") {
      host.recalculateTotals();
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if(document.querySelector(".product-page--wrapper .product-page--info .product-bulk-buy-buttons--root .product-bulk-buy-buttons--cta")){
    document.querySelector(".product-page--wrapper .product-page--info .product-bulk-buy-buttons--root .product-bulk-buy-buttons--cta").removeAttribute("id");
  }
});

document.addEventListener('click', function(e){
  if (e.target.closest(".b2b-addtocart-btn")) {
      e.preventDefault();
      let product_id = e.target.closest(".b2b-addtocart-btn").id;
      let hiddenBtn = document.getElementById(product_id + "-product-buy-buttons-custom-add-to-cart");
      if (hiddenBtn) {
        hiddenBtn.click();
      }
  }
});

// Intercept cart drawer checkout for wholesale customers

document.addEventListener('DOMContentLoaded', function () {
  // Helper: get customer tags (from window.saw_customer or tag on body)
  function isWholesaleCustomer() {
    if (window.saw_customer && Array.isArray(window.saw_customer.tags)) {
      return window.saw_customer.tags.some(function(tag){ return String(tag).toLowerCase() === 'wholesale'; });
    }
    if (document.body.classList.contains('wholesale')) return true;
    return false;
  }

  // Helper: get discount code from input (if present)
  function getDrawerDiscountCode() {
    var input = document.querySelector('.cstm-cart-drawer .saso-use-discount-code-cart-code');
    return input ? input.value.trim() : '';
  }

  // UI helpers for drawer checkout button
  function setCheckoutButtonLoading(btn) {
    var drawer = btn.closest('.cstm-cart-drawer');
    if (!drawer) return;
    var wrapper = drawer.querySelector('.cart--checkout-button');
    if (!wrapper) return;
    var textEl = drawer.querySelector('.cart--checkout-button .cart-button--text');
    var spinnerEl = drawer.querySelector('.cart--checkout-button .cart-button--spinner');
    if (textEl) textEl.style.display = 'none';
    if (spinnerEl) spinnerEl.style.display = 'inline-block';
  }
  
  // Poll the invoice URL briefly with a hard cap to reduce delay
  function pollInvoiceAvailability(url, intervalMs, maxDurationMs) {
    return new Promise(function(resolve) {
      var start = Date.now();
      var done = false;
      function finish(result) {
        if (done) return; done = true; resolve(result);
      }
      function tryOnce() {
        if (Date.now() - start >= maxDurationMs) {
          return finish(false);
        }
        var sep = url.indexOf('?') > -1 ? '&' : '?';
        var pingUrl = url + sep + '_=' + Date.now();
        fetch(pingUrl, {
          method: 'GET',
          mode: 'cors',
          cache: 'no-store',
          redirect: 'follow'
        })
        .then(function(response) {
          if (response && (response.ok || response.status === 200)) {
            finish(true);
          } else {
            setTimeout(tryOnce, intervalMs);
          }
        })
        .catch(function() {
          setTimeout(tryOnce, intervalMs);
        });
      }
      // immediate first attempt, then repeat at the interval until time cap
      tryOnce();
    });
  }
  function setCheckoutButtonProcessing(btn) {
    var drawer = btn.closest('.cstm-cart-drawer');
    if (!drawer) return;
    var wrapper = drawer.querySelector('.cart--checkout-button');
    if (!wrapper) return;
    var textEl = drawer.querySelector('.cart--checkout-button .cart-button--text');
    var spinnerEl = drawer.querySelector('.cart--checkout-button .cart-button--spinner');
    if (textEl) {
      textEl.textContent = 'Processing...';
      textEl.style.display = 'inline-block';
    }
    if (spinnerEl) spinnerEl.style.display = 'none';
  }
  function resetCheckoutButton(btn) {
    var drawer = btn.closest('.cstm-cart-drawer');
    if (!drawer) return;
    var wrapper = drawer.querySelector('.cart--checkout-button');
    if (!wrapper) return;
    var textEl = drawer.querySelector('.cart--checkout-button .cart-button--text');
    var spinnerEl = drawer.querySelector('.cart--checkout-button .cart-button--spinner');
    if (textEl) textEl.style.display = '';
    if (spinnerEl) spinnerEl.style.display = 'none';
  }

  // Intercept checkout button in cart drawer only
  document.body.addEventListener('click', async function (event) {
    const checkoutBtn = event.target.closest('.cstm-cart-drawer .cart--checkout-button button[name="checkout"]');
    if (!checkoutBtn) return;

    if (!isWholesaleCustomer()) {
      // Not wholesale, allow normal checkout
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    checkoutBtn.disabled = true;
    checkoutBtn.classList.add('loading');
    setCheckoutButtonLoading(checkoutBtn);

    // Ensure we have the latest cart
    try {
      const latestCart = await fetch('/cart.js?_=' + Date.now()).then(function(r){ return r.json(); });
      if (latestCart) {
        window.saw_cart = latestCart;
      }
    } catch (e) {}

    // Gather cart/customer data (from window.saw_cart, window.saw_customer)
    var cart = window.saw_cart || null;
    var customer = window.saw_customer || null;
    var discountCode = getDrawerDiscountCode();
    if (!discountCode && window.sawDocCookies && typeof window.sawDocCookies.getItem === 'function') {
      var cookieCode = window.sawDocCookies.getItem('saw_discount_code');
      if (cookieCode) discountCode = cookieCode;
    }
    var shopSlug = "destira-leotards";
    var baseUrl = "https://sawholesale.herokuapp.com";

    var postData = {
      shop_slug: shopSlug,
      cart: cart,
      customer: customer
    };
    if (discountCode) postData.discount_code_cart = discountCode;

    // Add note if present
    var noteInput = document.querySelector('.cstm-cart-drawer [name="note"]');
    if (noteInput && noteInput.value) postData.note = noteInput.value;

    // Add note_attributes if present
    var noteAttributes = [];
    var attributesList = document.querySelectorAll('.cstm-cart-drawer [name^="attributes"]');
    attributesList.forEach(function(el) {
      if (el.value == "") return;
      var name = el.name.replace(/^attributes\[/i, "").replace(/\]$/i, "");
      var v = { name: name, value: el.value };
      if (el.tagName.toLowerCase() === "input" && el.type === "checkbox") {
        if (el.checked) noteAttributes.push(v);
      } else {
        noteAttributes.push(v);
      }
    });
    if (noteAttributes.length) postData.note_attributes = noteAttributes;

    // POST to wholesale API for draft order
    try {
      const res = await fetch(baseUrl + "/api/v1/cart-check-discounts?checkout=draft", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(postData)
      }).then(function(r){ return r.json(); });

      // API responded — set Processing... and hide spinner
      setCheckoutButtonProcessing(checkoutBtn);

      if (res && res.invoice_url) {
        // Brief, capped poll (~1.2s max) to reduce race without long waits
        try {
          await pollInvoiceAvailability(res.invoice_url, 200, 1200);
        } catch (e) {}
        window.location.href = res.invoice_url;
        console.log(res.invoice_url);
      } else {
        // fallback: normal checkout
        window.location.href = "/checkout";
      }
    } catch (err) {
      alert("Error creating wholesale checkout. Please try again.");
      resetCheckoutButton(checkoutBtn);
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('loading');
      return;
    }
  }, true); // useCapture to intercept before form submit
});